import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import {
  ChipIconTimes,
  ChipIconPencil,
  ChipIconOpenNew,
  ChipIconInfo,
  ChipIconPreview
} from './ChipIcons'

import {
  StyledChip,
  StyledChipLabel,
  StyledChipIconWrapper
} from './Chip.styles'

//  import chipStyles from './Chip.scss'

const chipStyles = ['times', 'pencil', 'newtab', 'info', 'preview']

export const CHIP_SIZE_LG = 'lg'

export const Chip = React.memo(
  ({
    className,
    icon,
    label,
    children,
    onClick,
    size,
    value,
    disabled,
    'data-mu-test': dataAttributeTest
  }) => {
    const handleClick = e => {
      e.persist()
      e.stopPropagation()
      if (typeof onClick === 'function') {
        onClick(value, e)
      }
    }

    return (
      <StyledChip
        $clickable={(!!onClick).toString()}
        $disabled={disabled}
        $lg={size === CHIP_SIZE_LG}
        $icon={icon}
        $additionalClassName={className}
        onClick={handleClick}
        data-mu-test={classnames('chip', dataAttributeTest)}
      >
        <StyledChipLabel className='e-chip__label'>{label}</StyledChipLabel>
        {icon === 'times' && (
          <StyledChipIconWrapper>
            <ChipIconTimes />
          </StyledChipIconWrapper>
        )}
        {icon === 'pencil' && (
          <StyledChipIconWrapper>
            <ChipIconPencil />
          </StyledChipIconWrapper>
        )}
        {icon === 'newtab' && (
          <StyledChipIconWrapper>
            <ChipIconOpenNew />
          </StyledChipIconWrapper>
        )}
        {icon === 'info' && (
          <StyledChipIconWrapper>
            <ChipIconInfo />
          </StyledChipIconWrapper>
        )}
        {icon === 'preview' && (
          <StyledChipIconWrapper>
            <ChipIconPreview />
          </StyledChipIconWrapper>
        )}
        {children}
      </StyledChip>
    )
  }
)

Chip.defaultProps = {
  disabled: false
}

// this is bad. We should investigate a way to check proptypes
// in jest test. JSON.parse fail due to identity-obj-proxy

Chip.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.oneOf(chipStyles),
  label: PropTypes.string,
  size: PropTypes.string, //  deprecated
  onClick: PropTypes.func,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}

export { StyledChipIconWrapper as ChipIconWrapper }
